import React from 'react'
import { usePageContext } from './page-context'
import { useSrcSets } from './components/useSrcSets'

export const withImages = (Component, selectors) => props => {
  const { images } = usePageContext()
  // console.log('withImages', images)
  const selectedImages = selectors
    .map(selector => {
      const { childImageSharp, ...image } =
        images.find(image => image.base === props[selector.key]) || {}

      return {
        key: selector.key,
        value: selector.target
          ? image[selector.target]
          : selector.fluid
          ? childImageSharp && childImageSharp.fluid
          : childImageSharp && useSrcSets(childImageSharp, 650),
      }
    })
    .reduce((acc, selector) => ({ ...acc, [selector.key]: selector.value }), {})

  return <Component {...props} {...selectedImages} />
}
